export default {"src":"/statics/ecommerce/_next/static/media/big-white.1fe95b75.svg","height":187,"width":391,"blurWidth":0,"blurHeight":0};